export default function () {
	const cardFilter = document.querySelectorAll('.js-card-filter');
	cardFilter.forEach(filter => {
		const cardGrid = filter.querySelector('.js-card-grid');
		const fullCardGridItems = Array.from(cardGrid.querySelectorAll('li'));
		const tabItems = filter.querySelectorAll('.js-nav-side-tabs .js-tab-item');
		const moreLinkContainer = filter.querySelector('.js-see-more');
		let currentLength = getCardGridLength();
		setGridClass(currentLength)

		function setGridClass(itemsLength) {
			cardGrid.classList.add(`dr-card-grid-${itemsLength}`);
			currentLength = itemsLength;
		}
		function removeGridClass(itemsLength) {
			cardGrid.classList.remove(`dr-card-grid-${itemsLength}`)
		}
		function getCardGridLength() {
			//return current number of items
			const gridItems = cardGrid.querySelectorAll('li');
			return gridItems ? gridItems.length : 0
		}
		function setDefaultGrid() {
			//set default number of items
			fullCardGridItems.forEach(item => {
				cardGrid.appendChild(item)
			})
		}
		if(tabItems.length) {
			function onTabClick(event) {
				event.stopPropagation();
				cleanTabClass(); //remove current tab class
				setDefaultGrid(); //add default number of items
				removeGridClass(currentLength); //set the class value based on the number of elements

				const currentTabType = event.target.dataset.type;
				const currentTabLink = event.target.dataset.link;
				const currentTabText = event.target.dataset.text;
				const currentTab = event.target.parentElement;
				currentTab.classList.add('uk-active');

				if (currentTabType !== 'Featured') {
					fullCardGridItems.forEach(item => {
						//removing items that do not match the current tab
						if (item.dataset.type !== currentTabType) {
							item.remove();
						}
					})
				}

				if(moreLinkContainer) {
					if (currentTabLink) {
						moreLinkContainer.classList.remove('uk-hidden');
						moreLinkContainer.querySelector('.js-see-more-link').href = currentTabLink
						moreLinkContainer.querySelector('.js-see-more-name').innerHTML = currentTabText || currentTabType;
					} else {
						moreLinkContainer.classList.add('uk-hidden');
					}
				}

				setGridClass(getCardGridLength())
			}
			function cleanTabClass() {
				tabItems.forEach(tab => {
					tab.classList.remove('uk-active');
				});
			}
			tabItems.forEach(tab => {
				tab.addEventListener('click', (event) => onTabClick(event));
			});
		}
	})
}
